"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const GithubIcon = createIcon({
  displayName: "GithubIcon",
  viewBox: "0 0 45 43",
  path: (
    <>
      <path
        d="M22.5,0C10.07,0,0,9.87,0,22.05c0,9.74,6.45,18,15.38,20.92,1.12.21,1.54-.47,1.54-1.06,0-.52-.02-1.91-.03-3.75-6.26,1.33-7.58-2.96-7.58-2.96-1.02-2.54-2.5-3.22-2.5-3.22-2.04-1.37.16-1.34.16-1.34,2.26.15,3.45,2.27,3.45,2.27,2.01,3.37,5.27,2.4,6.55,1.83.2-1.43.78-2.4,1.43-2.95-5-.55-10.25-2.45-10.25-10.89,0-2.41.87-4.37,2.32-5.92-.25-.56-1.01-2.8.2-5.83,0,0,1.88-.59,6.19,2.26,1.8-.49,3.71-.73,5.62-.74,1.91.01,3.83.25,5.62.74,4.27-2.85,6.16-2.26,6.16-2.26,1.21,3.04.45,5.28.23,5.83,1.43,1.54,2.31,3.51,2.31,5.92,0,8.47-5.26,10.33-10.27,10.88.79.66,1.52,2.01,1.52,4.08,0,2.95-.03,5.32-.03,6.04,0,.58.39,1.27,1.55,1.05,9-2.89,15.44-11.16,15.44-20.89C45,9.87,34.93,0,22.5,0Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default GithubIcon;
